import {
  PaginationHandler,
  PaginationInfo,
  usePaginatedQuery,
} from '@occc-app/hooks/usePaginatedQuery';
import { useGetSegmentUploadedFilesQuery } from '@occc/graphql';

import { usePollingControl } from './use-polling-control.hook';

import { POLLING_INTERVAL_MS } from '../segments.constants';

export type UseGetSegmentUploadedFilesParams = {
  segmentUuid: string;
  paginationInfo: PaginationInfo;
  onPageChange: PaginationHandler;
  isPollingEnabled?: boolean;
  pollInterval?: number;
};

export const useGetSegmentUploadedFiles = ({
  segmentUuid,
  paginationInfo,
  onPageChange,
  isPollingEnabled = false,
  pollInterval = POLLING_INTERVAL_MS,
}: UseGetSegmentUploadedFilesParams) => {
  const response = usePaginatedQuery(
    useGetSegmentUploadedFilesQuery,
    'segmentUploadedFiles.pageInfo',
    undefined,
    {
      skip: !segmentUuid,
      variables: {
        uuid: segmentUuid,
      },
      ...(isPollingEnabled && { pollInterval }),
    },
    paginationInfo,
    onPageChange,
  );

  usePollingControl(isPollingEnabled, response.stopPolling);

  return response;
};
